import React from 'react'

import withFirebaseAuth from '../data/withFirebaseAuth'
import withCurrentUser from '../data/withCurrentUser'
import MenuContainer from './misc/MenuContainer'
import Toasts from './misc/Toasts'
import Routes from './Routes'
import {
  AppWrapper,
  AppBackground,
} from './styles'

const App = (props) => (
  <AppWrapper>
    <AppBackground />
    <Routes {...props} />
    <MenuContainer {...props} />
    <Toasts />
  </AppWrapper>
)

export default withFirebaseAuth(withCurrentUser(App))



// WEBPACK FOOTER //
// ./src/views/App.jsx